export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">精选盘点</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">热门漫画深度解读与推荐，帮你发现好作品</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20style%20scene%20with%20romantic%20couple%20in%20modern%20Seoul%20cityscape%2C%20warm%20evening%20lighting%2C%20soft%20color%20palette%2C%20webtoon%20aesthetic%2C%20clean%20background&width=800&height=450&seq=media-01&orientation=landscape"
                alt="2024韩漫年度盘点：十部必看高分作品"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-md font-medium">韩漫推荐</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5" />
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors">2024韩漫年度盘点：十部必看高分作品</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">从甜蜜恋爱到悬疑反转，盘点今年口碑炸裂的韩漫佳作，漫荒必收。</p>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20young%20adventurers%20in%20fantasy%20world%2C%20dynamic%20composition%2C%20vibrant%20colors%2C%20anime%20aesthetic%2C%20clean%20white%20background%20with%20subtle%20gradient&width=800&height=450&seq=media-02&orientation=landscape"
                alt="日漫新番速递：七月最值得期待的连载"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-md font-medium">日漫大全</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5" />
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors">日漫新番速递：七月最值得期待的连载</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">热血少年、奇幻冒险、治愈日常……七月日漫新番全面解析，抢先锁定追更清单。</p>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20traditional%20hanfu%20characters%20in%20ancient%20Chinese%20landscape%2C%20ink%20wash%20painting%20influence%2C%20elegant%20composition%2C%20soft%20warm%20tones%2C%20clean%20artistic%20background&width=800&height=450&seq=media-03&orientation=landscape"
                alt="国漫崛起：值得收藏的经典国风漫画"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-md font-medium">国漫排行榜</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center">
                  <i className="ri-play-fill text-xl text-primary-500 ml-0.5" />
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors">国漫崛起：值得收藏的经典国风漫画</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">从古风仙侠到现代都市，国漫排行榜上的常青树作品，每一部都值得细细品味。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}